import React from 'react';
import '@fortawesome/fontawesome-free/css/all.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/pages/Home';
import Checkout from './components/pages/Checkout';
import TrackOrder from './components/pages/TrackOrder';
import VerifyDelivery from './components/pages/VerifyDelivery';
import ResetPassword from './components/pages/ResetPassword';
import AdminDashboard from './components/pages/AdminDashboard';
import CheckoutFeedback from './components/pages/CheckoutFeedback';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/track' element={<TrackOrder />} />
        <Route path='/verify' element={<VerifyDelivery />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/admin' element={<AdminDashboard />} />
        <Route path='/feedback' element={<CheckoutFeedback />} />
      </Routes>
      <footer className='site-footer'>
        <div className='footer-inner'>
          <div className='brand-lockup'>
            <span className='brand-mark' aria-hidden='true'>M</span>
            <span>Mukwei Gin</span>
          </div>
          <div className='footer-legal'>
            <p>Please enjoy responsibly. Not for sale to persons under the age of 18.</p>
            <p>
              Mukwei Gins (Pty) Ltd is the seller and is solely responsible for all products,
              payments, orders, delivery and fulfilment. Phanda Studios provides hosting and web
              development services only and accepts no responsibility for order fulfilment.
            </p>
          </div>
          <p>© 2026 Mukwei Gins (Pty) Ltd · Proudly South African</p>
        </div>
      </footer>
    </Router>
  );
}

export default App;
